/* ============================================================
   Oasis Nutrition — Mobile sticky Add to Cart
   The sticky button proxies the real Add to Cart button so the
   existing flavor-picker validation and variant locking run
   exactly as they do for the in-page button. It never submits
   the form itself, so nothing in the buying flow is bypassed.
   ============================================================ */
(function () {
  if (!('customElements' in window)) return;

  class OasisStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id');
      this.proxyBtn = this.querySelector('[data-oasis-sticky-add]');
      this.priceEl = this.querySelector('.oasis-sticky-atc__price');

      // The real in-page Add to Cart button rendered by buy-buttons.liquid.
      this.realBtn = document.getElementById('ProductSubmitButton-' + this.sectionId);
      // The in-page price block rendered for this section.
      this.mainPrice =
        document.getElementById('price-' + this.sectionId) ||
        document.querySelector('.product__info-wrapper .price');

      if (!this.proxyBtn || !this.realBtn) {
        this.remove();
        return;
      }

      this.onProxyClick = this.onProxyClick.bind(this);
      this.proxyBtn.addEventListener('click', this.onProxyClick);

      this.syncState();
      this.syncPrice();
      this.observeRealButton();
      this.observeChanges();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
      if (this.priceMo) this.priceMo.disconnect();
    }

    // Forward the tap to the real button: this triggers the form submit,
    // which runs the flavor-picker capture-phase validation untouched.
    onProxyClick() {
      if (this.realBtn.disabled) return;
      this.realBtn.click();
    }

    // Reveal the bar only while the real button is out of view, so the
    // shopper never sees two Add to Cart buttons at once.
    observeRealButton() {
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0 }
      );
      this.io.observe(this.realBtn);
    }

    // Mirror the real button's disabled/label state (sold out, unavailable).
    syncState() {
      this.proxyBtn.disabled = this.realBtn.disabled;
      var realLabel = this.realBtn.querySelector('span');
      if (realLabel && realLabel.textContent.trim()) {
        this.proxyBtn.textContent = realLabel.textContent.trim();
      }
    }

    syncPrice() {
      if (!this.priceEl || !this.mainPrice) return;
      var saleItem = this.mainPrice.querySelector('.price-item--sale');
      var regularItem = this.mainPrice.querySelector('.price-item--regular');
      var source = saleItem && saleItem.textContent.trim() ? saleItem : regularItem;
      if (source) this.priceEl.textContent = source.textContent.trim();
    }

    // The custom selectors re-render price/button via the Section Rendering
    // API; keep the sticky bar in sync when that happens.
    observeChanges() {
      var self = this;
      this.mo = new MutationObserver(function () {
        self.syncState();
      });
      this.mo.observe(this.realBtn, { attributes: true, attributeFilter: ['disabled'], subtree: true, childList: true });

      if (this.mainPrice) {
        this.priceMo = new MutationObserver(function () {
          self.syncPrice();
        });
        this.priceMo.observe(this.mainPrice, { childList: true, subtree: true });
      }
    }
  }

  if (!customElements.get('oasis-sticky-atc')) {
    customElements.define('oasis-sticky-atc', OasisStickyAtc);
  }
})();
